/* eslint-disable */
import React from "react";
import { Select, TextField } from "mui-rff";
import { Form } from "react-final-form";
import { useTranslation } from "react-i18next";
import { LoadingButton } from "@mui/lab";
import { TStepOneForm } from "@/features/user/register/stepOne/types";
import MenuItemModalForm from "@/components/modal/MenuItemModalForm";
import { AutocompleteWrapper as Autocomplete } from "@/components/forms";
import { Grid } from "@mui/material";
import SimpleSpinner from "@/components/spinner/simpleSpinner";

const StepOneForm = (
    {
        onSubmit,
        initialValues,
        validateForm,
        required,
        submitting,
        selectDataTaxRegime,
        selectDataPaymentForm,
        selectDataPaymentMethod,
        selectDataCFDIUse,
        selectDataCustoms,
        selectDataCurrencies,
        selectDataDecimals,
        isModal,
        closePopover,
        setModalOpen,
        loading
    }: TStepOneForm): any => {


    const [t] = useTranslation();



    const formFields: any[] = [
        {
            field:
                <Autocomplete
                    placeholder={t("step_one.placeholder_tax_regime")}
                    limitTags={1}
                    label={t("step_one.label_tax_regime")}
                    name="cat_tax_regimes_id"
                    multiple={false}
                    required={required.cat_tax_regimes_id}
                    options={selectDataTaxRegime}
                    selectOnFocus
                    clearOnBlur
                    handleHomeEndKeys
                    disableClearable={true}
                    disableCloseOnSelect={false}
                    textFieldProps={{
                        InputLabelProps: { shrink: true }
                    }}
                />
        },
        {
            field:
                <TextField
                    InputLabelProps={{ shrink: true }}
                    label={t("step_one.label_curp")}
                    name="curp"
                    required={required.curp}
                />
        },
        {
            field:
                <TextField
                    InputLabelProps={{ shrink: true }}
                    label={t("step_one.label_employer_registration")}
                    name="employer_registration"
                    required={required.employer_registration}
                />
        },
        {
            field:
                <TextField
                    InputLabelProps={{ shrink: true }}
                    label={t("step_one.business_name")}
                    name="business_name"
                    required={required.business_name}
                />
        },
        {
            field:
                <Autocomplete
                    placeholder={t("step_one.placeholder_payment_form")}
                    limitTags={1}
                    label={t("step_one.label_payment_form")}
                    name="cat_payment_forms_id"
                    multiple={false}
                    required={required.cat_payment_forms_id}
                    options={selectDataPaymentForm}
                    selectOnFocus
                    clearOnBlur
                    handleHomeEndKeys
                    disableClearable={true}
                    disableCloseOnSelect={false}
                    textFieldProps={{
                        InputLabelProps: { shrink: true }
                    }}
                />
        },
        {
            field:
                <Autocomplete
                    placeholder={t("step_one.placeholder_payment_method")}
                    limitTags={1}
                    label={t("step_one.label_payment_method")}
                    name="cat_payment_methods_id"
                    multiple={false}
                    required={required.cat_payment_methods_id}
                    options={selectDataPaymentMethod}
                    selectOnFocus
                    clearOnBlur
                    handleHomeEndKeys
                    disableClearable={true}
                    disableCloseOnSelect={false}
                    textFieldProps={{
                        InputLabelProps: { shrink: true }
                    }}
                />
        },
        {
            field:
                <Autocomplete
                    placeholder={t("step_one.placeholder_cfdi_use")}
                    limitTags={1}
                    label={t("step_one.label_cfdi_use")}
                    name="cat_usoscfdi_id"
                    multiple={false}
                    required={required.cat_usoscfdi_id}
                    options={selectDataCFDIUse}
                    selectOnFocus
                    clearOnBlur
                    handleHomeEndKeys
                    disableClearable={true}
                    disableCloseOnSelect={false}
                    textFieldProps={{
                        InputLabelProps: { shrink: true }
                    }}
                />
        },
        {
            field:

                <Select
                    label={t("step_one.label_customs")}
                    name="customs"
                    required={required.customs}
                    data={selectDataCustoms}
                    multiple={false}
                    inputLabelProps={{ shrink: true }}
                    displayEmpty
                />

        },
        {
            field:
                <Select
                    label={t("step_one.label_currency")}
                    name="cat_currencies_id"
                    required={required.cat_currencies_id}
                    data={selectDataCurrencies}
                    multiple={false}
                    inputLabelProps={{ shrink: true }}
                    displayEmpty
                />
        },
        {
            field:

                <Select
                    label={t("step_one.label_decimals")}
                    name="decimals"
                    required={required.decimals}
                    data={selectDataDecimals}
                    multiple={false}
                    inputLabelProps={{ shrink: true }}
                    displayEmpty
                />

        },
    ];

    const modalProps: any = {
        hasMenuItem: true,
        label: t('step_one.title'),
        title: t('step_one.title'),
        formFields,
        onSubmit,
        initialValues,
        validateForm,
        required,
        submitting,
        closePopover,
        setModalOpen,
        loading
    }

    return (
        <>
            {
                !isModal &&
                <Form
                    onSubmit={onSubmit}
                    initialValues={initialValues}
                    validate={validateForm}
                    render={({ handleSubmit, errors }) => {
                        //console.log('s1 errors', errors);
                        return (
                            <>
                                {loading && <SimpleSpinner/>}
                                {!loading &&
                                    <form onSubmit={handleSubmit} noValidate>
                                        <Grid container spacing={2}>
                                            {formFields.map((item, idx) => (
                                                <Grid item md={4} sm={12} xs={12} key={idx}>
                                                    {item.field}
                                                </Grid>
                                            ))}
                                        </Grid>
                                        <LoadingButton
                                            sx={{mt: 3, mr: 1}}
                                            //fullWidth
                                            size="large"
                                            type="submit"
                                            variant="contained"
                                            loading={submitting}
                                        >
                                            {t("common.save")}
                                        </LoadingButton>
                                    </form>
                                }
                            </>
                        );
                    }}
                />
            }

            {
                isModal &&
                <MenuItemModalForm
                    {...modalProps}
                />
            }

        </>

    );
}

export default StepOneForm;
